module.exports = __webpack_public_path__ + "img/related-people.svg";